import type { RouteObject } from "react-router-dom";

import { ServiceInvoicesPage } from "./service-invoices/service-invoices-page";

export const billingRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Billing" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page hidePadding={() => true} /> };
    },
    children: [
      {
        path: "service-invoices",
        handle: { breadcrumb: "Service invoices" },
        element: <ServiceInvoicesPage />,
      },
    ],
  },
];
